// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popform {
  height: 327px;
  position: absolute;
  justify-content: space-between;
  right: 30px;
  width: 500px;
  padding: 5px;
}

.teleinfo {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.forminput {
  width: 100%;
  padding-top: 10px;
}

.forminput > div {
  width: 100%;
  padding-bottom: 10px;
  padding-top: 10px;
}

.redstar {
  color: red;
}

.formTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.fullForm {
  height: 510px;
  padding-left: 20px;
  overflow-y: scroll;
}

.forminput input {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./components/CreateHook/CreateHook.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AACF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAEF;;AAAA;EACE,WAAA;EACA,iBAAA;AAGF;;AADA;EACE,WAAA;EACA,oBAAA;EACA,iBAAA;AAIF;;AAFA;EACE,UAAA;AAKF;;AAFA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAKF;;AAFA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;AAKF;;AAFA;EACE,WAAA;AAKF","sourcesContent":[".popform {\n  height: 327px;\n  position: absolute;\n  justify-content: space-between;\n  right: 30px;\n  width: 500px;\n  padding: 5px;\n}\n.teleinfo {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.forminput {\n  width: 100%;\n  padding-top: 10px;\n}\n.forminput > div {\n  width: 100%;\n  padding-bottom: 10px;\n  padding-top: 10px;\n}\n.redstar {\n  color: red;\n}\n\n.formTitle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.fullForm {\n  height: 510px;\n  padding-left: 20px;\n  overflow-y: scroll;\n}\n\n.forminput input {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
